import './style.scss';
import { DateTime } from 'luxon';
import type { ILine } from '../../../../models/line.model';
import LineListShowcase from '../../../Shared/LineListShowcase';
import { TranslationService } from '../../../../services/translation.service';
import { ConfigurationService } from '../../../../services/configuration.service';

function createLinkText(line: ILine) {
  let result = `${TranslationService.get('timetablespage.timetablelinktext')} ${TranslationService.get('common.line').toLocaleLowerCase()} ${line.shortName} ${line.directionName}`;
  if (!!line.appliesFrom && line.appliesFrom > DateTime.now()) {
    result = `${result} (${TranslationService.get('common.from').toLocaleLowerCase()} ${line.appliesFrom.toFormat('yyyy-MM-dd')})`;
  }
  return result;
}

function TimetablesLine({ line, className }: { line: ILine; className?: string }) {
  const linkUrl = `${ConfigurationService.get('timetablespage.baseurl')}${line.gid}/`;

  return (
    <div className={`timetables-line print-no-break ${className ?? ''}`}>
      <div className="timetables-line__content-wrapper p-3">
        <LineListShowcase lines={[line]} show-non-train-direction-name={true} show-train-direction-name={true} show-applies-from-date-on-future-lines={true} className="mb-2" />
        <a className="timetables-line__link-wrapper" href={linkUrl}>
          {createLinkText(line)}
        </a>
      </div>
    </div>
  );
}

export default TimetablesLine;
